import { useEffect, useState } from "react";
import { Menu, Phone, Sun } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { CONTACT } from "@/config/site";

const NAV = [
  ["types", "Solar Types"],
  ["categories", "Categories"],
  ["pm-yojana", "PM Yojana"],
  ["why", "Why Us"],
  ["process", "Process"],
  ["contact", "Contact"],
];

export const Logo = ({ testId = "header-logo", dark = false }) => (
  <a href="/#top" data-testid={testId} className="flex items-center gap-3">
    <span className="grid h-11 w-11 place-items-center rounded-2xl bg-gold shadow-[0_8px_24px_-6px_rgba(245,158,11,0.6)]">
      <Sun className="h-6 w-6 text-navy-950" strokeWidth={2.5} />
    </span>
    <span className="leading-none">
      <span className={`block font-display text-[22px] sm:text-2xl font-extrabold tracking-tight ${dark ? "text-white" : "text-navy-900"}`}>
        Anuj <span className={dark ? "text-gold" : "text-gold-deep"}>Solar</span>
      </span>
      <span className={`mt-1 block whitespace-nowrap text-[9px] sm:text-[11px] uppercase tracking-[0.14em] sm:tracking-[0.2em] ${dark ? "text-slate-400" : "text-slate-500"}`}>Anuj Saur Urja Sales</span>
    </span>
  </a>
);

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const f = () => setScrolled(window.scrollY > 24);
    f();
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 transition-[background-color,border-color] duration-300 border-b ${
        scrolled ? "bg-cream-50/80 backdrop-blur-xl border-slate-200" : "bg-transparent border-transparent"
      }`}
    >
      <div className="container-x flex h-[72px] sm:h-20 items-center justify-between gap-4">
        <Logo dark={!scrolled} />
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map(([id, label]) => (
            <a key={id} href={`#${id}`} data-testid={`nav-link-${id}`} className={`text-[15px] font-medium transition-colors ${scrolled ? "text-slate-600 hover:text-gold-ink" : "text-white/90 hover:text-gold-light"}`}>
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={CONTACT.tel} data-testid="header-call-button" aria-label="Call करें" className="btn-gold h-11 whitespace-nowrap px-4 sm:px-5 text-[15px]">
            <Phone className="h-4 w-4" /> <span className="hidden min-[400px]:inline sm:inline">Call करें</span>
          </a>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="mobile-menu-button" aria-label="Menu" className="lg:hidden grid h-11 w-11 place-items-center rounded-full border border-slate-300 bg-white text-navy-900 shadow-sm">
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-cream-50 border-slate-200 text-navy-900 w-[85vw] max-w-sm">
              <SheetTitle className="sr-only">Menu</SheetTitle>
              <div className="mt-10 flex flex-col gap-1">
                {NAV.map(([id, label]) => (
                  <a key={id} href={`#${id}`} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${id}`} className="rounded-xl px-4 py-4 text-xl font-semibold text-slate-800 hover:bg-slate-100 hover:text-gold-ink">
                    {label}
                  </a>
                ))}
                <a href={CONTACT.tel} data-testid="mobile-menu-call-button" className="btn-gold mt-6 h-14 text-lg">
                  <Phone className="h-5 w-5" /> {CONTACT.phoneDisplay}
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
